import { render, staticRenderFns } from "./PermissionControll.vue?vue&type=template&id=4b3017f5&scoped=true"
import script from "./PermissionControll.vue?vue&type=script&lang=js"
export * from "./PermissionControll.vue?vue&type=script&lang=js"
import style0 from "./PermissionControll.vue?vue&type=style&index=0&id=4b3017f5&prod&lang=less"
import style1 from "./PermissionControll.vue?vue&type=style&index=1&id=4b3017f5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3017f5",
  null
  
)

export default component.exports